import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { HeaderPrimaryNav } from './styles.js';
export { HEADER_PRIMARY_NAV_TEST_ID, HeaderPrimaryNav } from './styles.js';

/**
 * The "red" primary row in the header. The primary row can optionally be made "sticky" on smaller screens
 * as the user scrolls down the page.
 */

const HeaderPrimary = forwardRef(({
  children,
  isStickySmallScreen = false
}, ref) => jsx(HeaderPrimaryNav, Object.assign({
  isStickySmallScreen: isStickySmallScreen,
  ref: ref
}, {
  children: children
}), void 0));
HeaderPrimary.displayName = 'HeaderPrimary';

export { HeaderPrimary };
